var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-banner'),_c('home-nav'),_vm._l((_vm.moduleData),function(item,index){return _c('home-module',{key:index,attrs:{"moduleData":item}})}),_c('v-free-apply')],2)}
var staticRenderFns = []

export { render, staticRenderFns }